import React, { FC, useState, useCallback, useEffect, } from 'react';
import { useTranslation } from 'react-i18next';
// import { useHistory, useLocation } from 'react-router-dom';
import { Content, PageHeader, AlertBar, TypeTable} from 'scorer-ui-kit';
import styled from 'styled-components';
import { searchResult } from 'services/apiConfig';
import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import DateInput from '../components/DateInput';
import { dateFormat } from '../utils/index';
import format from 'date-fns/format';
import {DATE_FORMAT_WITH_SEC } from '../constants';
import { useParams } from 'react-router';

const Container = styled(Content)`
`;

const HeaderContainer = styled.div`
  margin-bottom: 47px;
  > div:first-child > div > h1 {
    max-width: 650px;
    overflow-wrap: break-word;
    white-space: break-spaces;
    min-width: 200px !important;
  }
  & > div > div > div:nth-child(3){
    bottom: 4px;
  }
  & > div > p {
    font-weight: normal;
    font-style: normal;
  }
  position: relative;
  max-width: 940px !important;
`;

const InnerContainer = styled.div`
  margin-left: 1px;
`;


const PageHeaderFormatter = styled.div`
  svg {
    margin-top: -7px;
  }
`;




const FlexColumn = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 20px 2px;
`;


const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  column-gap: 9px;
  align-items: center;
  margin-bottom: 10px;
`;



const TableContainer = styled.div`
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    padding: 5px;
  }
  th {
    text-align: left;
  }
  margin: 60px 0px;
`;


const AlertBarContainer = styled.div`
  margin: 25px 0px;
  width: 80%;
`;


const DataSourceContainer = styled.div`
  margin-top: 30px;
`;

const SubTitle = styled.label`
  font-size: 16px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  color: #5a6269;
  margin: 0;
  padding: 0;
`;

interface IInterval {
  start: Date,
  end: Date
}

interface IParams {
  streamName: string;
}





const CameraResults: FC = () => {
  const { t } = useTranslation(['CommonDict']);
  // const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const [resultData, setResultData] = useState<any>([]);
  const [pageContent, setPageContent] = useState<any>([]);

  const { streamName } = useParams<IParams>();
  

  const [alert, setAlert] = useState<IAlert | null>(null);
    
  const startDate = dateFormat(new Date());
  startDate.setDate(startDate.getDate() - 1);
  const [defaultDate,] = useState<IInterval>({ start: startDate, end: dateFormat(new Date()) });
  const [initialStartDate, setInitialStartDate] = useState<Date>(defaultDate.start);
  const [initialEndDate, setInitialEndDate] = useState<Date>(defaultDate.end);

  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const showTotal: PaginationProps['showTotal'] = (total) => `Total ${total} items`;
  

  const updateStartDate = useCallback((date) => {
    if (initialEndDate.getTime() - 60000 <= date.getTime() || date > dateFormat(new Date())) {
      setAlert({
        key: new Date(),
        message: t('Please select \'From\' date smaller then now date and \'To\' date. '),
        type: 'error'
      });
      return;
    }
    setInitialStartDate(date);
  }, [initialEndDate, t]);

  const updateEndDate = useCallback((date) => {
    if (initialStartDate >= date || date > dateFormat(new Date())) {
      setAlert({
        key: new Date(),
        message: t('Please select \'To\' date smaller then now and greater then \'From\' date. '),
        type: 'error'
      });
      return;
    }
    setInitialEndDate(date);
  }, [initialStartDate, t]);


  const onQuerryTbl = useCallback(async () => {
    setTableLoading(true);
    let response:any = {};
    try {
      response = await searchResult({ date_range: {start_date: format(initialStartDate, DATE_FORMAT_WITH_SEC), end_date: format(initialEndDate, DATE_FORMAT_WITH_SEC)}, stream_name: streamName});
      if(response.status === 200) {
        if(response.data.data.length === 0){
          setAlert({
            key: new Date(),
            message: t('No Data Found'),
            type: 'error'
          });
        }else{
          setAlert({
            key: new Date(),
            message: t(''),
            type: 'error'
          });
        }
        setResultData(response.data.data);
        setTableLoading(false);
      } else {
        setTableLoading(false);
        setAlert({
          key: new Date(),
          message: t('Failed to search for result.'),
          type: 'error'
        });
      }
    } catch {
      setTableLoading(false);
      setAlert({
        key: new Date(),
        message: t('Failed to search for result.'),
        type: 'error'
      });
    }
  }, [t, initialStartDate, initialEndDate, streamName]);

  useEffect(() => {
    onQuerryTbl();
  }, [onQuerryTbl]);


 
  const handleTableData = useCallback(() => {
    
    if(resultData.length > 0){
      const arrData = [];
      const alertArr:any = [];
      const copiedObj = [...resultData].slice((page - 1) * pageSize, page * pageSize);
      for (let i = 0; i < copiedObj.length; i++) {
        arrData.push({columns: [
          {text: copiedObj[i].area_name}, 
          {text: copiedObj[i].date}, 
          {text: copiedObj[i].count}, 
          {text: copiedObj[i].ratio_value}, 
          {text: copiedObj[i].vqa_result ? copiedObj[i].vqa_result : 'N/A'}, 
          {text: copiedObj[i].vqa_master ? copiedObj[i].vqa_master : 'N/A'}, 
        ],
        header: {image: copiedObj[i].img, mediaType: 'img', mediaUrl: copiedObj[i].img} 
        ,id: `tblrow${i+1}`});

        //add index of row that has value is_reported = 1
        if(copiedObj[i].is_reported === 1){
          alertArr.push(i+1);
        }
      } 
      
      setPageContent(arrData);

      //wait until table shows up
      setTimeout(function(){
        const camTbl = document.getElementById('camTbl');
        
        const tblRows = camTbl?.childNodes[0].childNodes[0].childNodes;
        if(tblRows){
          //set vqa column width
          const vqa = tblRows[0].childNodes[5];
          (vqa as HTMLElement).style.width = '35%';
          
          for (let x = 0; x < tblRows.length; x++) {
            if(alertArr.includes(x)){
              const tblCells = tblRows[x].childNodes;
              for (let y = 0; y < tblCells.length; y++) {
                // add alert color to cells except cell that contains image
                if(y!==0){
                  (tblCells[y] as HTMLElement).style.backgroundColor = '#FCBFCB';
                }
                
              }
              
            } else {
              const tblCells = tblRows[x].childNodes;
              for (let y = 0; y < tblCells.length; y++) {
                // remove color to cells 
                (tblCells[y] as HTMLElement).style.backgroundColor = ''; 
              }
            }
          }
        }
      }, 300);
    } else {
      setPageContent([{ columns: [] }]);
    }
    
  
  },[resultData, page, pageSize]);


  useEffect(() => {
    handleTableData();
  }, [handleTableData]);

  const columnConfig: any=[
    {
      cellStyle: 'normalImportance',
      header: t('Area Name'),
      alignment: 'center',
      columnId: 'area_name',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Datetime'),
      alignment: 'center',
      columnId: 'date',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Count Number'),
      alignment: 'center',
      columnId: 'count',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: t('Ratio'),
      alignment: 'center',
      columnId: 'ratio_value',
      sortable: true
    },
    {
      cellStyle: 'normalImportance',
      header: 'VQA',
      alignment: 'left'
    },
    {
      cellStyle: 'normalImportance',
      header: t('VQA Master'),
      alignment: 'center'
    }
  ];

  const handleSort = useCallback(async (ascending: boolean, columnId: string) => {
    try {
      const copiedData = [...resultData];
      if(ascending){
        copiedData.sort((a, b) => a[columnId].localeCompare(b[columnId]));
      }else{
        copiedData.sort((a, b) => -1 * a[columnId].localeCompare(b[columnId]));
      }      
      setResultData(copiedData);

    }
    catch(err) {
      console.error(err);
    }
  }, [resultData]);


  return (
    <Container>
      <HeaderContainer>
        <PageHeaderFormatter>
          <PageHeader
            title={t('Camera Results')}
            icon='FilterSorting'
            introductionText=''
            updateDocTitle={false}
          />
        </PageHeaderFormatter>
      </HeaderContainer>
      <InnerContainer>
        <>
          {alert &&
            <AlertBarContainer>
              <AlertBar message={alert?.message} type={alert?.type} />
            </AlertBarContainer>}
          <DataSourceContainer>
            <>{t('Camera Name')}：{streamName}</>
          </DataSourceContainer>
          <DataSourceContainer>
            <FlexContainer>
              <SubTitle>{t('Select Time Range')}</SubTitle>
            </FlexContainer>
            <FlexColumn>
              <DateInput labelText={t('From')} date={initialStartDate} callBackFunction={updateStartDate} />
              <DateInput labelText={t('To')} date={initialEndDate} callBackFunction={updateEndDate} />
            </FlexColumn>
          </DataSourceContainer>
          <TableContainer id='camTbl'>
            <TypeTable
              columnConfig={columnConfig}
              emptyTableText={t('There is currently no data')}
              emptyTableTitle={t('No Data Available')}
              isLoading={tableLoading}
              loadingText='Loading Data..'
              hasThumbnail
              rows={pageContent}
              sortCallback={handleSort}
            />
            {resultData.length > 0 && 
              <Pagination
                current={page}
                size='small'
                pageSize={pageSize}
                onChange={(newPage, newPageSize) => {
                  setPageSize(newPageSize);
                  setPage(pageSize !== newPageSize ? 1 : newPage);
                }}
                showSizeChanger
                total={resultData.length}
                showTotal={showTotal}
                style={{ marginTop: '18px', textAlign: 'center'}}
              />}
          </TableContainer>
        </>
      </InnerContainer>
    </Container>
  );
};

export default CameraResults;